import { gql, useMutation } from '@apollo/client';
import { GqlError, formatErrors } from '../utils/errors';
import { sanitizeUrl } from '../utils/transformers';

const UPDATE_VIRTUAL_EVENT_URL_MUTATION = gql`
  mutation updateVirtualEventUrlMutation(
    $id: Int!,
    $url: String,
  ) {
    updateVirtualEventUrlById(input: {
      id: $id,
      virtualEventUrlPatch: {
        url: $url,
      }
    }) {
      virtualEventUrl {
        id
        url
        memberEventId
      }
    }
  }
`;

const useUpdateVirtualEventUrl = (onCompleted) => {
  const [updateVirtualEventUrlMutation, { loading, data, error }] = useMutation(
    UPDATE_VIRTUAL_EVENT_URL_MUTATION,
    { onCompleted },
  );

  const updateVirtualEventUrl = async ({ id, url, memberEventId }) => {
    try {
      const response = await updateVirtualEventUrlMutation({
        variables: {
          id,
          url: url ? sanitizeUrl(url.trim()) : null,
          memberEventId,
        },
      });
      return response.data.updateVirtualEventUrl;
    } catch (e) {
      const formattedErrors = formatErrors(e);
      throw new GqlError({
        name: 'Virtual Event URL Error',
        errors: formattedErrors,
      });
    }
  };

  return [
    updateVirtualEventUrl,
    {
      loading,
      data,
      error: error ? formatErrors(error) : null,
    },
  ];
};

export default useUpdateVirtualEventUrl;
